import { ConnectedProps, connect, useSelector } from "react-redux";
import { actions } from "reducers/slots";
import { SlotsFilterType, SlotsTabs } from "reducers/types/slots";
import { AppDispatch, RootState } from "store";
import { Slots } from "./Slots";
import { SlotsContainerPropsType } from "./types";
import { slotSelector } from "reducers/slots";
import { sessionSelector } from "reducers/session";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const SlotsContainer = (
  props: SlotsContainerPropsType & ConnectorProps
): JSX.Element => {
  const { countryCode } = useSelector(sessionSelector);
  const history = useHistory();
  const location = useLocation();
  const [shouldRenderTabContent, setShouldRenderTabContent] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab") as SlotsTabs;
    if (tab && (tab === "slots" || tab === "templates")) {
      props.setActualPage(tab);
    }
    setShouldRenderTabContent(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, props.setActualPage]);

  const changePage = (page: SlotsTabs) => {
    props.setActualPage(page);
    history.replace(`/${countryCode}/slots?tab=${page}`);
  };
  return (
    <Slots
      {...props}
      changePage={changePage}
      testId="slots"
      shouldRender={shouldRenderTabContent}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  actualPage: slotSelector(state).actualPage,
  filters: slotSelector(state).filters,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setActualPage: (page: SlotsTabs) => {
    dispatch(actions.setActualPage(page));
  },
  exportSlots: (params: SlotsFilterType) => {
    dispatch(actions.exportSlotsRequest(params));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(SlotsContainer);
